import FormControl from '@material-ui/core/FormControl';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import InputLabel from '@material-ui/core/InputLabel';
import React from 'react';
import { createSelector } from 'reselect';
import CloseIcon from '@material-ui/icons/Close';
import Input from '@material-ui/core/Input';
import DamFilterButton from '../../button/DamFilterButton';

interface IDamFilterSelectorProps {
    id ?: string;
    fullWidth ?: boolean;
    required ?: boolean;

    label : string;
    disabled ?: boolean;

    code : string | null;
    name : string | null;
    type : string | null;
    division : string | null;
    managementArea : string | null;
    inspectionDue : boolean | null;

    onChange ?: (
        code : string | null,
        name : string | null,
        type : string | null,
        division : string | null,
        managementArea : string | null,
        inspectionDue : boolean | null,
    ) => void;
}

interface IDamFilterSelectorState {
    open : boolean;
}

export default class DamFilterSelector extends React.PureComponent<IDamFilterSelectorProps, IDamFilterSelectorState> {
    constructor(props : IDamFilterSelectorProps) {
        super(props);
        this.state = {
            open: false,
        };
    }

    private readonly onFilterIconButtonClick = () => {
        this.toggleOpen(!this.state.open);
    };

    private readonly onFilterFocusClick = () => {
        this.toggleOpen(true);
    };

    private readonly onClearClick = () => {
        this.onChange(null, null, null, null, null, null,);
    };

    public readonly onChange = (
        code : string | null,
        name : string | null,
        type : string | null,
        division : string | null,
        managementArea : string | null,
        inspectionDue : boolean | null,
    ) => {
        this.setState({
            open: false,
        });

        if (!this.props.onChange) return;
        this.props.onChange(code, name, type, division, managementArea, inspectionDue);

    };

    private readonly toggleOpen = (open : boolean) => {
        this.setState({
            open,
        });
    };

    private readonly getCode = (props : IDamFilterSelectorProps) => props.code;
    private readonly getName = (props : IDamFilterSelectorProps) => props.name;
    private readonly getType = (props : IDamFilterSelectorProps) => props.type;
    private readonly getDivision = (props : IDamFilterSelectorProps) => props.division;
    private readonly getManagementArea = (props : IDamFilterSelectorProps) => props.managementArea;

    private readonly getLabel = createSelector(
        [
            this.getCode,
            this.getName,
            this.getType,
            this.getDivision,
            this.getManagementArea,
        ],
        (code, name, type, division, managementArea) => {
            const result = [];

            if (code) result.push(code);
            if (name) result.push(name);
            if (type) result.push(type);
            if (division) result.push(division);
            if (managementArea) result.push(managementArea);

            return result.join(' - ');
        },
    );

    public readonly render = () => {
        const { required, fullWidth, label, id,
            code, name, type, division, managementArea,
            disabled, inspectionDue } = this.props;
        const { open } = this.state;

        const value = this.getLabel(this.props);
        return (
            <FormControl fullWidth={fullWidth} error={required && !code} required={required}>
                <InputLabel htmlFor={id}>{label}</InputLabel>
                <Input
                    onFocus={this.onFilterFocusClick}
                    onChange={undefined}
                    value={value}
                    readOnly
                    endAdornment={
                        <InputAdornment position='end'>
                            {
                                (code || name || type || division || managementArea) &&
                                <IconButton
                                    aria-label='clear filter'
                                    onClick={this.onClearClick}
                                >
                                    <CloseIcon className='cr' />
                                </IconButton>
                            }
                            <DamFilterButton
                                color='primary'
                                id='Dams_filter'
                                open={open}
                                onClick={this.onFilterIconButtonClick}
                                onChange={this.onChange}
                                name={name}
                                code={code}
                                type={type}
                                division={division}
                                managementArea={managementArea}
                                inspectionDue={inspectionDue}
                                disabled={disabled}
                            />
                        </InputAdornment>
                    }
                />
            </FormControl>
        );
    };
}
